import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgBellRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.125 4.125v.629a5.346 5.346 0 0 1 4.5 5.277v1.175c0 1.596.545 3.146 1.54 4.394l.524.654a.842.842 0 0 1-.657 1.371H4.969a.844.844 0 0 1-.659-1.371l.524-.654a7.04 7.04 0 0 0 1.541-4.394V10.03a5.346 5.346 0 0 1 4.5-5.277v-.629a1.124 1.124 0 1 1 2.25 0m-1.406 2.25a3.66 3.66 0 0 0-3.656 3.656v1.175a8.73 8.73 0 0 1-1.395 4.732h10.666a8.73 8.73 0 0 1-1.396-4.732V10.03a3.66 3.66 0 0 0-3.656-3.656zM14.25 18.75c0 .566-.235 1.17-.657 1.593A2.3 2.3 0 0 1 12 21a2.25 2.25 0 0 1-1.592-.657 2.3 2.3 0 0 1-.658-1.593z"
    }));
export default SvgBellRegular;
